import styled from "styled-components";

export const StyledCameraSelect = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  h4 {
    font-size: var(--font-size-md);
    color: var(--color-text-80);
    font-weight: 500;
  }
`;
